export default {
	network_error: "Network Error",
	common: {
		loading: "Loading...",
		loadFailed: "Load Failed",
	},
	error: {
		pageNotFound: "Page Not Found",
		goBack: "Back to Home",
	},
	tabbar: {
		pandapass: "Pandapass",
		ecny: "E-CNY",
		center: "Center",
		shop: "Shop",
		my: "My",
	},
	refresh: {
		pulling: "Pull down to refresh...",
		loosing: "Release to refresh...",
		loading: "Loading...",
	},
	home: {
		search: "Search",
		pandapass: "Pandapass",
		bannerDescription: "Covering nearly 30 attractions you can recoup your investment with just one visit!",
		hotScenicSpot: "Hot Scenic Spot",
		liveStyle: "Live style",
		filter: "Filter",
		picker_confirm: "Confirm",
		picker_cancel: "Cancel",
		all: "All",
		restaurant: "Restaurant",
		hotel: "Hotel",
		entertainment: "Entertainment",
		free: "Free with Pandapass",
		originalPrice: "Original Price:",
		noData: "No content",
		useBtn: "To use",
		buyBtn: "To buy",
	},
	packagePurchase: {
		title: "Buy Package",
		quantity: "Quantity",
		paymentMethod: "Payment Method",
		total: "Total",
		payNow: "Pay Now",
		wechat: "WeChat",
		alipay: "Alipay",
		unionpay: "Unionpay",
		creditcard: "Creditcard",
	},
	packageDetail: {
		title: "Package Details",
		pandapass: "Pandapass",
		bannerDescription: "Covering nearly 30 attractions you can recoup your investment with just one visit!",
		packageTitle: "Pandapass Privilege Package",
		packageDescription: "Covering nearly 30 attractions you can recoup your investment with just one visit!",
		originalPrice: "Original Price",
		freeScenicSpot: "Free Scenic Spot",
		liveStyle: "Live Style",
		pandapassFree: "Pandapass Free",
		noData: "No content",
		totalPrice: "Total Price",
		buyNow: "Buy Now",
		purchased: "Purchased",
		pleaseLogin: "Please login first",
		purchaseSuccess: "Purchase successful!",
	},
	search: {
		cancel: "Cancel",
		searchHistory: "Search History",
		topSearches: "Top Searches",
		searchResults: "Search Results for",
		noResults: "No results found",
		searching: "Searching...",
	},
	ecny: {
		title: "Digital Currency",
		digitalCurrency: "E-CNY",
		description: "Experience the future of digital payments with China's official digital currency.",
		secure: "Secure & Reliable",
		fast: "Fast Transactions",
		convenient: "Convenient Payment",
		noCardMessage: "You don't have an E-CNY card yet. You need to add one before you can use it.",
		walletTitle: "E-CNY Wallet",
		walletDescription:
			"It is a legal digital currency issued by the People's Bank of China, mainly used for cash in circulation (M0). It is operated by designated institutions and available for exchange by the general public. The currency exists in electronic form, and its value is equivalent to that of RMB banknotes and coins.",
		addNow: "Add now",
		recharge: "Recharge",
		activeWallet: "Activate the wallet",
		enterCard: "Please enter your card number",
		confirm: "Confirm",
		errorMessage: "Please enter a 16 digit card number",
		checkingWallet: "Checking wallet status...",
	},
	recharge: {
		title: "Balance Recharge",
		rechargeAmount: "Recharge Amount",
		otherAmount: "Other Amount",
		otherAmountPlaceholder: "Please enter the recharge amount",
		paymentMethod: "Payment Method",
		rechargeNow: "Recharge Now",
		selectAmount: "Please select or enter recharge amount",
		rechargeInProgress: "Recharge feature in development...",
		cardStatus: "Activated",
	},
	shop: {
		title: "Shop",
		buy: "Buy",
		scenic: "Scenic Spot",
		entertainment: "Entertainment",
		food: "Food",
	},
	my: {
		order: {
			allOrders: "All Orders",
			Processing: "Processing",
			Completed: "Completed",
			afterSales: "After-Sales",
		},
		address: "Address",
		ai: "Pandapass AI agent",
		register: "Register/Login",
		exit: "Exit",
		confirmTitle: "Reminder",
		confirm: "Confirm",
		cancel: "Cancel",
		confirmMessage: "Are you sure you want to log out?",
		pleaseLogin: "Please login first",
	},
	shopCart: {
		title: "Shopping Cart",
		total: "Total",
		buy: "Buy",
		delete: "Delete",
		emptyCart: "Your shopping cart is empty",
		stockNotEnough: "Stock not enough",
		discontinued: "Discontinued",
	},
	order: {
		sendParcel: "Send a parcel",
		pickUp: "Pick up",
		chooseAnotherAddress: "Choose another shipping address",
		buy: "Buy",
		orderNumber: "Order Number",
		orderStatus: "Order Status",
		waitPayment: "Pending Payment",
		paid: "Paid",
		shipped: "Shipped",
		received: "Received",
		completed: "Completed",
		cancelled: "Cancelled",
		timeout: "Timeout",
		paymentTimeout: "Payment Timeout",
		orderTotal: "Order Total",
		deliveryFee: "Delivery Fee",
		actualPayment: "Actual Payment",
		paymentMethod: "Payment Method",
		deliveryMethod: "Delivery Method",
		recipientInfo: "Recipient Info",
		recipientName: "Recipient Name",
		recipientPhone: "Phone Number",
		recipientAddress: "Address",
		orderTime: "Order Time",
		paymentTime: "Payment Time",
		deliveryTime: "Delivery Time",
		completeTime: "Complete Time",
		orderRemark: "Order Remark",
		itemCount: "items",
		moreItems: "and {count} more items",
		cancelOrder: "Cancel Order",
		loading: "Loading...",
		noOrders: "No Orders",
		goShopping: "Go Shopping",
		confirmReceive: "Confirm Receipt",
		applyAfterSales: "Apply After-Sales",
		viewAfterSales: "View After-Sales",
		cancelAfterSales: "Cancel After-Sales",
		deleteOrder: "Delete Order",
		confirmDelete: "Confirm Delete",
		confirmDeleteMessage: "Are you sure you want to delete this order?",
		// 订单状态
		statusWaitPay: "Pending Payment",
		statusWaitShipping: "Pending Shipment",
		statusWaitReceive: "Pending Receipt",
		statusCompleted: "Completed",
		statusAfterSale: "After-Sales",
		statusTimeout: "Timeout",
		statusUnknown: "Unknown Status",
		statusAfterSaleReturn: "After-Sales Return",
		statusAfterSaleCancel: "After-Sales Cancel",
		// 提示信息
		getOrderListFailed: "Failed to get order list",
		// 地址相关
		completeAddress: "Please complete recipient information",
		enterAddress: "No delivery address",
		completePickupAddress: "Please select pickup point",
		noPickupPoints: "No pickup points available",
		// 支付相关
		processing: "Processing",
		payProcessing: "Payment processing",
		paymentConfirm: "Payment Confirmation",
		paymentConfirmMessage: "Please confirm you have completed payment",
		confirm: "Confirm",
		cancel: "Cancel",
		getOrderDetailFailed: "Failed to get order details",
		networkError: "Network error, please try again later",
		operationSuccess: "Operation successful",
		operationFailed: "Operation failed",
		orderCancelSuccess: "Order cancelled successfully",
		cancelOrderFailed: "Failed to cancel order",
		updateOrderStatusFailed: "Failed to update order status",
		unpaidOrderCannotApplyAfterSales: "Unpaid orders cannot apply for after-sales service",
		completedOrderCannotApplyAfterSales: "Completed orders cannot apply for after-sales service",
		alreadyInAfterSales: "Order is already in after-sales process",
		notInAfterSales: "Order is not in after-sales process",
		// 确认对话框
		confirmCancel: "Confirm Cancel",
		confirmCancelMessage: "Are you sure you want to cancel this order?",
		confirmReceiveTitle: "Confirm Receipt",
		confirmReceiveMessage: "Have you received the goods?",
		confirmApplyAfterSalesMessage: "Are you sure you want to apply for after-sales service?",
		confirmCancelAfterSalesMessage: "Are you sure you want to cancel after-sales service?",
		// 订单详情页面
		copy: "Copy",
		shippingInformation: "Shipping Information",
		receivingAddress: "Receiving Address",
		orderNumberCopied: "Order number copied",
		copyFailed: "Copy failed",
		orderIdRequired: "Order ID is required",
		loadFailed: "Load failed",
		orderDetails: "Order Details",
		remark: "Remark",
		// Refresh related
		refreshSuccess: "Refresh Success",
		refreshFailed: "Refresh Failed",
		statusAfterSaleReject: "After-Sales Reject",
		iGotIt: "I got it",
		vipOrderPaymentProcessing: "Order processing",
		vipOrderPaymentProcessingMessage: "The current order has not detected the payment status (it may still be processing), and will be redirected to the order list page",
		// Payment related error messages
		getDefaultAddressFailed: "Failed to get default address",
		getPickupPointsFailed: "Failed to get pickup points",
		paymentParamError: "Payment parameter error",
		paymentCallFailed: "Payment call failed, please try again",
		linkCopied: "Link copied, please open in browser",
		copyFailed2: "Copy failed, please copy link manually",
		paymentProcessing: "Payment processing, please confirm later",
		paymentFailed: "Payment failed, please try again",
		paymentCancelled: "Payment cancelled",
		paymentStatusUnknown: "Payment status unknown, please confirm payment result",
		// Payment dialog
		paymentTip: "Payment Tip",
		wechatPaymentTip: "Detected you are in WeChat, please copy the link and open it in browser to complete payment",
		copyLink: "Copy Link",
		jumpingToAlipay: "Jumping to Alipay...",
		// Default values
		defaultPickupPoint: "Pickup Point",
		userOrderRemark: "User order",
	},
	orderList: {
		orderTitle: "Order List",
		all: "All",
		Processing: "Processing",
		ToShipping: "To Shipping",
		Delivering: "Delivering",
		Completed: "Completed",
		AfterSales: "After-Sales",
		goPay: "Go Pay",
		afterSalesBtn: "After-Sales",
	},
	address: {
		title: "Address",
		setAsDefault: "Set as default",
		defaultSet: "Set as default address",
		editInProgress: "Edit feature in development...",
		deleteConfirmTitle: "Confirm Delete",
		deleteConfirmMessage: "Are you sure you want to delete this address?",
		deleteSuccess: "Address deleted successfully",
		addInProgress: "Add address feature in development...",
		consignee: "Consignee",
		enterRecipientName: "Enter recipient name",
		phoneNumber: "Phone number",
		enterPhoneNumber: "enter your phone number",
		address: "Address",
		place_name: "Hotel / Building / etc.",
		enterPlaceName: "Enter place name",
		houseNumber: "House number",
		enterHouseNumber: "Enter the house number",
		save: "Save",
		locating: "Locating...",
		pleaseCompleteForm: "Please complete the form",
		saveSuccess: "Saved successfully",
		editShippingAddress: "Edit shipping address",
		addShippingAddress: "Add shipping address",
	},
	deliveryDetail: {
		title: "Delivery in progress",
		expectedArrival: "Order is on the way",
		actualPaymentAmount: "Actual payment amount",
		orderNumber: "Order Number",
		copy: "Copy",
		deliveryMethod: "Delivery Method",
		delivery: "Delivery",
		orderTime: "Order time",
		paymentTime: "Payment time",
		shippingInformation: "Shipping Information",
		receivingAddress: "Receiving address",
		pickupPhone: "Pickup phone",
		pickupAddress: "Pickup address",
		business_hours: "Business hours",
		deliveryTime: "Delivery Time",
		carrier: "Carrier",
		contractor_phone: "Contractor phone",
		contractor: "Contractor",
	},
	paymentResult: {
		home: "Home",
		checking: "Checking order status...",
		success: "Payment Successful",
		failed: "Payment Failed",
		finshed: "Transaction Completed",
		close: "Close",
	},
	productDetail: {
		commodityInfo: "Commodity information",
		forYou: "For You",
		addToCart: "add to cart",
		buy: "Buy",
		quantity: "Number",
		addToCartSuccess: "Added to cart",
		buyInProgress: "Buy feature in development...",
		navigationInProgress: "Navigation feature in development...",
	},
	codeView: {
		notLoggedInMessage: "You have not logged into your account, so your QR code cannot be displayed.",
		notBuyPackageMessage: "You have not purchased a card yet.",
		goToLogin: "Go to log in",
		goToBuy: "Buy now",
		loginInProgress: "Redirecting to login page...",
		goToUse: "Can be used",
		expired: "Expired",
		qrcodeError: "Please switch the QR code or repurchase.",
	},
	detail: {
		title: "Pandapass Benefits",
		freeBtn: "Pandapass is free",
		originalPrice: "Original Price",
		useBtn: "To use",
		travelInfo: "Travel Information",
		scenicHours: "Open all year round",
		foodHours: "Business Hours",
		navigation: "Navigation",
		call: "Call",
		video: "Video",
		image: "Image",
		introduction: "Introduction",
		selectMap: "Select Map",
		amap: "Amap",
		google: "Google Maps",
		apple: "Apple Maps",
		tencent: "Tencent Maps",
		baidu: "Baidu Maps",
	},
	center: {
		title: "Service Center",
		subtitle: "One-stop service platform",
		quickActions: "Quick Actions",
		scan: "Scan",
		pay: "Pay",
		transfer: "Transfer",
		actionExecuting: "Executing",
		feature1: {
			title: "Smart Recommendations",
			description: "Get personalized service recommendations",
		},
		feature2: {
			title: "Fast Response",
			description: "Millisecond response for ultimate experience",
		},
		feature3: {
			title: "Secure & Safe",
			description: "Multi-layer encryption for fund security",
		},
		feature4: {
			title: "Caring Service",
			description: "24/7 professional customer support",
		},
	},
	register: {
		title: "Register",
		phoneEmail: "Email",
		phoneEmailPlaceholder: "Please enter email address",
		emailCode: "Email code",
		emailCodePlaceholder: "Please enter the verification code",
		getCode: "Get Code",
		password: "Password",
		passwordPlaceholder: "Please enter password",
		confirmPassword: "Confirm password",
		confirmPasswordPlaceholder: "Please enter password again",
		register: "Register",
		haveAccount: "Have an account?",
		login: "Log in",
		enterPhoneEmailFirst: "Please enter email address first",
		codeSent: "Verification code sent",
		codeSendFailed: "Verification code sending failed",
		pleaseCompleteForm: "Please complete the form",
		registering: "Registering...",
		registerSuccess: "Registration successful",
	},
	login: {
		title: "Login",
		phoneEmail: "Email",
		phoneEmailPlaceholder: "Please enter email address",
		password: "Password",
		passwordPlaceholder: "Please enter password",
		login: "Login",
		noAccount: "No account?",
		register: "Register",
		pleaseCompleteForm: "Please complete the form",
		loginInProgress: "Logging in...",
	},
	api: {
		success: "Operation successful",
		paramError: "Parameter error",
		userExist: "User already exists",
		codeError: "Verification code error",
		registerSuccess: "Registration successful",
		codeUsed: "The verification code has expired",
		loginSuccess: "Login successful",
		userNotExist: "User does not exist",
		passwordError: "Password error",
		rateLimitExceeded: "Request too frequent, please try again later",
		addToCartSuccess: "Added to cart",
		productNotExist: "Product not on sale",
		stockNotEnough: "Stock not enough",
		vipOrderCreateSuccess: "Order created successfully",
		vipOrderCreateFailed: "Order creation failed",
		vipOrderNotExist: "Order does not exist",
		vipOrderNotPayment: "Not paid",
		vipOrderPaymentSuccess: "Payment successful",
		vipOrderPaymentFailed: "Payment failed",
		vipOrderPaymentTimeout: "Payment timeout",
		vipOrderListFailed: "Failed to get order list",
		vipOrderStatusUpdateFailed: "Failed to update order status",
		vipOrderStatusUpdateSuccess: "Order status updated successfully",
		vipOrderCancelFailed: "Failed to cancel order",
		vipOrderCancelSuccess: "Order cancelled successfully",
		paidOrderCannotCancel: "Shipped orders cannot be cancelled",
		itemsRequired: "The product has been ordered or does not exist",
		invalidDeliveryType: "Invalid delivery type",
		invalidPaymentMethod: "Invalid payment method",
		deliveryAddressRequired: "Delivery address is required for delivery orders",
		pickupAddressRequired: "Pickup address is required for pickup orders",
		ecnyBindSuccess: "Card bound successfully",
		ecnyBindFailed: "Card binding failed",
		ecnyInvalidCardNumber: "Invalid card number format, please enter 16 digits",
		ecnyCardNotFound: "Card number not found or already bound",
		ecnyEmailNotMatch: "Your email does not match the card, please contact customer service",
		ecnyUserAlreadyBound: "You have already bound another card",
		ecnyCheckFailed: "Failed to check wallet status",
		ecnyWalletFound: "Wallet is bound",
		ecnyWalletNotFound: "Wallet is not bound",
		applyAfterSalesSuccess: "After-sales application successful",
		applyAfterSalesFailed: "Failed to apply for after-sales service",
		cancelAfterSalesSuccess: "After-sales cancellation successful",
		cancelAfterSalesFailed: "Failed to cancel after-sales service",
		packageCountExceeded: "Pandapass privilege package limited to 5 purchases",
		qrcodeNotFound: "The QR code does not exist",
		qrcodeExpired: "The QR code has expired",
		qrcodeAlreadyUsed: "The QR code has already been used",
		qrcodeUsedSuccess: "The QR code has been used successfully",
		qrcodeUpdateFailed: "The QR code update failed",
		iGotIt: "I got it",
		vipOrderDeleteSuccess: "Order deleted successfully",
		vipOrderDeleteFailed: "Failed to delete order",
		orderCannotDelete: "Order cannot be deleted",
	},
};
